import React, { Component } from 'react';
import './MatinCategoryButton.scss';
import i18n from '../../../i18n';
import{connect} from'react-redux'
const containerStyle = {
    maxWidth : 440
}
const menuStyle = {
    width : 206
}
class MainCategoryButton extends Component {
    render() {
        const { onClick ,whichMainCateGoryClick ,value} = this.props
        return (
            <div className={`MainCategoryButton-container`} style={value ==="jp" ? containerStyle : null}>
                <div className={`${whichMainCateGoryClick === "marketing" ?"active" : ""}`} style={value ==="jp" ? menuStyle : null} onClick={() =>onClick("marketing")}>{i18n.t("designselect.mainCategory.marketing")}</div>
                <div className={`${whichMainCateGoryClick === "social" ?"active" : ""}`} style={value ==="jp" ? menuStyle : null} onClick={() =>onClick("social")}>{i18n.t("designselect.mainCategory.social")}</div>
            </div>
        );
    }
}

export default MainCategoryButton;